/**
 * Infinite scroll for the Surfboards collection page.
 * Progressive enhancement: the standard numbered pagination (snippets/pagination.liquid)
 * stays in the markup and only gets hidden once this script confirms it can take over.
 * If a page fetch ever fails, we fall back to showing the normal pagination links again.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('ProductGridSurfboards');
    var paginationWrap = document.getElementById('CollectionPaginationSurfboards');
    var trigger = document.getElementById('InfiniteScrollTrigger');
    var status = document.getElementById('InfiniteScrollStatus');

    if (!grid || !paginationWrap || !trigger || !window.fetch || !window.IntersectionObserver) {
      // No pagination to worry about, or the browser can't do this — leave native pagination visible.
      return;
    }

    var totalPages = parseInt(paginationWrap.getAttribute('data-total-pages'), 10) || 1;
    var currentPage = parseInt(paginationWrap.getAttribute('data-current-page'), 10) || 1;
    var loading = false;
    var basePath = window.location.pathname;

    // Hand off from native pagination to infinite scroll now that we know JS is working.
    paginationWrap.setAttribute('hidden', 'hidden');

    function setStatus(text) {
      if (!status) return;
      if (text) {
        status.textContent = text;
        status.removeAttribute('hidden');
      } else {
        status.textContent = '';
        status.setAttribute('hidden', 'hidden');
      }
    }

    function fallbackToPagination() {
      paginationWrap.removeAttribute('hidden');
      observer.disconnect();
      setStatus(null);
    }

    function loadNextPage() {
      if (loading || currentPage >= totalPages) {
        return;
      }
      loading = true;
      var nextPage = currentPage + 1;
      setStatus('Loading more boards…');

      fetch(basePath + '?page=' + nextPage)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Request failed: ' + response.status);
          }
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('ProductGridSurfboards');

          if (!newGrid || !newGrid.children.length) {
            throw new Error('No products found on page ' + nextPage);
          }

          var items = Array.prototype.slice.call(newGrid.children);
          var fragment = document.createDocumentFragment();
          items.forEach(function (item) {
            fragment.appendChild(item);
          });
          grid.appendChild(fragment);

          // Let the theme re-init anything that targets individual grid items
          // (quick shop buttons, swatches, lazyload images, etc).
          if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
            window.theme.reinitProductGridItem();
          }

          currentPage = nextPage;

          if (window.history && window.history.replaceState) {
            var newUrl = basePath + (currentPage > 1 ? '?page=' + currentPage : '');
            window.history.replaceState({}, '', newUrl);
          }

          if (currentPage >= totalPages) {
            observer.disconnect();
            if (trigger.parentNode) {
              trigger.parentNode.removeChild(trigger);
            }
          }

          setStatus(null);
          loading = false;
        })
        .catch(function () {
          loading = false;
          fallbackToPagination();
        });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      },
      { rootMargin: '600px 0px 600px 0px' }
    );

    observer.observe(trigger);
  });
})();
